<i18n>
{
	"en": {
		"title": "APP Messages",
		"driver": "User",
		"type": "Type",
		"date": "Date",
		"text": "Message",
		"received": "Received",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"inbound": "Inbound",
		"outbound": "Outbound",
		"rejected": "Rejected",
		"unsuccessful": "Unsuccessful pickup",
		"requested": "Requested",
		"accepted": "Accepted",
		"noMessages": "There are no App Messages."
	},
	"no": {
		"title": "APP Messages",
		"driver": "Bruker",
		"date": "Dato",
		"text": "Message",
		"type": "Type",
		"terminal": "Terminal",
		"signature": "Signatur",
		"location": "Lokasjon",
		"received": "Mottatt",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"inbound": "Inngående",
		"outbound": "Utgående",
		"rejected": "Avslått",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Godtatt",
		"noMessages": "Det er ingen App meldinger."
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		icon="history"
		iconType="bp"
		:title="$t('title')"
		width="600px"
		@close="onClose"
		@shown="ready = true"
	>
		<t-grid
			v-if="ready && appMessages && appMessages.length > 0"
			:items="appMessages"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="40"
			:showFilters="false"
			:sort="[{field: 'date.date', direction: 'desc'}]"
			style="height: 400px; overflow-y:hidden;"
		>
			<template v-slot:driver="{ displayValue }">
				<div v-if="displayValue" style="height: 16px;">
					<template v-if="displayValue.name">
						{{displayValue.name}}
					</template>
					<template v-else-if="displayValue.email">
						{{displayValue.email}}
					</template>
					<template v-else-if="displayValue.phoneNumber">
						{{displayValue.phoneNumber}}
					</template>
				</div>
				<div v-if="displayValue && displayValue.name" class="grid-cell-sub-line">
					<template v-if="displayValue.email">
						{{displayValue.email}}
					</template>
					<template v-else-if="displayValue.phoneNumber">
						{{displayValue.phoneNumber}}
					</template>
				</div>
			</template>
			<template v-slot:date="{ item }">
				{{getDate(item.date)}}
			</template>
			<template v-slot:type="{ item }">
				{{$t(item.type)}}
			</template>
		</t-grid>
		<t-no-content-panel
			v-else
			:text="$t('noMessages')"
			icon="chat"
			iconType="bp"
			class="log-content"
		/>
	</t-dialog>
</template>

<script>
import { storageDateFormat } from '@/core';
import moment from 'moment';

export default {
	name: 'AppMessages',
	props: {
		isShown: Boolean,
		appMessages: Array
	},
	data() {
		return { ready: false };
	},
	computed: {
		columnDefinitions() {
			return [
				{
					field: 'driver',
					displayName: this.$t('driver'),
					valueGetter: (item) => item.driver ? item.driver.name : '',
					minWidth: 125,
				},
				{
					field: 'date.date',
					displayName: this.$t('date'),
					width: 150,
					valueGetter: (item) => this.getDate(item.date.date),
					type: 'date',
					dateFormat: 'DD.MM.YYYY HH:mm',
					comparableValueGetter: (item) => moment(item.date.epoch).toISOString(),
				},
				{
					field: 'type',
					displayName: this.$t('type'),
					minWidth: 70,
					width: 70,
					resizable: true,
				},
				{
					field: 'message',
					displayName: this.$t('text'),
				},
			];
		},
	},
	methods: {
		onClose() {
			this.ready = false;
			this.$emit('close');
		},
		getDate(date) {
			return moment(date, storageDateFormat).format('DD.MM.YYYY HH:mm');
		}
	}
};
</script>
